// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SMTPManagement-commonHeaderAdmin-vFB8a {
	position: fixed !important;
}

.SMTPManagement-adminLayout-q4BFn {
	padding-top: 64px !important;
}

.SMTPManagement-box-kqkZw h2 {
	font-size: 21px;
	font-weight: 600;
}

.SMTPManagement-exportLink-yMKsR {
	margin-bottom: -29px;
}

.SMTPManagement-blockCenter-klG4r {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.SMTPManagement-panelHeader-xaMfW {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.SMTPManagement-currencyselect-RPiRg {
	width: 100%;
	margin-right: 0px;
}

.SMTPManagement-panelHeader-xaMfW {
	overflow: hidden;
	position: relative;
}

.SMTPManagement-mar0-ROK5F {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.SMTPManagement-blockCenter-klG4r {
		padding: 0px;
	}

	.SMTPManagement-panelHeader-xaMfW {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.SMTPManagement-sideAdminPageWrapper-KauEn {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.SMTPManagement-panelHeader-xaMfW {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.SMTPManagement-table-ObOxD {
	display: table;
}

.SMTPManagement-tableRow-H2pnM {
	display: table-row;
}

.SMTPManagement-tableCell-LVBGo {
	display: table-cell;
	float: none;
}

.SMTPManagement-formGroup-Svxsv {
	margin-bottom: 6px;
}

.SMTPManagement-select-kfBXd {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.SMTPManagement-noMargin-OeHJM {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.SMTPManagement-exportLink-yMKsR {
	padding-top: 10px;
	padding-right: 10px;
}

.SMTPManagement-labelTextNew-Z3pxu {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.SMTPManagement-displayInline-vgPkj {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.SMTPManagement-btnUPdate-HQ8sU {
	display: inline-block;
}

.SMTPManagement-btnModalDelete-oeIW7 {
	display: inline-block;
	margin-left: 15px;
}

.SMTPManagement-radioBtn-DWC7f {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.SMTPManagement-backgroundImg-c4gkT {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.SMTPManagement-btnUPdate-HQ8sU {
		display: block;
		margin-bottom: 12px;
	}

	.SMTPManagement-btnModalDelete-oeIW7 {
		display: block;
		margin-left: 0px;
	}

	.SMTPManagement-btnWidth-aLce7 {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.SMTPManagement-bannerImageBg-EhXRf {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.SMTPManagement-bannerDelete-DFnbz {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.SMTPManagement-modalRoot-L8MJ5 {
	padding: 32px;
}

.SMTPManagement-modalBorderBottom-lBDQY {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.SMTPManagement-logInModalBody-Y54zN {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.SMTPManagement-exportSection-V71Ez {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.SMTPManagement-exportSectionGridSub-NJS2b {
	grid-template-columns: 50% 49% !important;
}

.SMTPManagement-exportText-t_m0C {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.SMTPManagement-exportLinkImg-wb67d {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.SMTPManagement-vtrMiddle-SJx_a {
	vertical-align: middle;
}

.SMTPManagement-exportImg-H8HKu {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.SMTPManagement-profileViewlabel-e8hUO {
	display: inline-block;
	width: 38%
}

.SMTPManagement-profileViewMainContent-qvYBM {
	display: inline-block;
	width: 62%;
}

.SMTPManagement-profileViewMain-oB747 {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.SMTPManagement-profileViewInner-iAK5J {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.SMTPManagement-profileImageSection-ieb0z {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.SMTPManagement-lastviewInner-EHnhV {
	padding: 10px;
}

.SMTPManagement-whyHostHoriLine-nRDCt {
	margin: 30px 0;
}

.SMTPManagement-tableGrid-GbUDH {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.SMTPManagement-headingContent-RAjLj {
	font-size: 18px;
	font-weight: 500;
}

.SMTPManagement-refundTextColor-sBxSw {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.SMTPManagement-dividerLine-p82Ms {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.SMTPManagement-smallContent-G4uTZ {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.SMTPManagement-sideAdminPageWrapper-KauEn {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.SMTPManagement-sideAdminPageWrapper-KauEn {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.SMTPManagement-exportSection-V71Ez {
		grid-template-columns: 100%;
	}

	.SMTPManagement-exportSectionGridSub-NJS2b {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.SMTPManagement-profileViewlabel-e8hUO {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.SMTPManagement-profileViewMainContent-qvYBM {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.SMTPManagement-ChangeToUpperCase-gokHN {
	text-transform: uppercase
}

.SMTPManagement-noBorder-liwoU {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.SMTPManagement-siteAdminHeading-lCRt0 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.SMTPManagement-siteAdminSubHeading-CJAma {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.SMTPManagement-adminFormDivider-DGo7p {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.SMTPManagement-space1-ZQD2i {
	margin-bottom: 6px !important;
}

.SMTPManagement-space2-z90In {
	margin-bottom: 12px !important;
}

.SMTPManagement-space3-KB1OW {
	margin-bottom: 18px !important;
}

.SMTPManagement-space4-PjH84 {
	margin-bottom: 24px !important;
}

.SMTPManagement-space5-AZCQb {
	margin-bottom: 30px !important;
}

.SMTPManagement-space6-JO7T0 {
	margin-bottom: 36px !important;
}

.SMTPManagement-space7-uCjih {
	margin-bottom: 42px !important;
}

.SMTPManagement-spaceTop8-K2dWL {
	margin-bottom: 48px !important;
}

.SMTPManagement-spaceTop1-BSjcy {
	margin-top: 6px !important;
}

.SMTPManagement-spaceTop2-oAW5i {
	margin-top: 12px !important;
}

.SMTPManagement-spaceTop3-h78M2 {
	margin-top: 18px !important;
}

.SMTPManagement-spaceTop4-BpiOO {
	margin-top: 24px !important;
}

.SMTPManagement-spaceTop5-g5MOo {
	margin-top: 30px !important;
}

.SMTPManagement-spaceTop6-WHmIN {
	margin-top: 36px !important;
}

.SMTPManagement-spaceTop7-cfKGM {
	margin-top: 42px !important;
}

.SMTPManagement-spaceTop8-K2dWL {
	margin-top: 48px !important;
}

.SMTPManagement-noMargin-OeHJM {
	margin: 0px !important;
}

.SMTPManagement-padding1-s2CpO {
	padding-bottom: 6px !important;
}

.SMTPManagement-padding2-qW52F {
	padding-bottom: 12px !important;
}

.SMTPManagement-padding3-0n8OX {
	padding-bottom: 18px !important;
}

.SMTPManagement-padding4-E1e1J {
	padding-bottom: 24px !important;
}

.SMTPManagement-padding5-P5mUh {
	padding-bottom: 30px !important;
}

.SMTPManagement-padding6-qxK_x {
	padding-bottom: 36px !important;
}

.SMTPManagement-padding7-Xq4u0 {
	padding-bottom: 42px !important;
}

.SMTPManagement-paddingTop1-pSQGL {
	padding-top: 6px !important;
}

.SMTPManagement-paddingTop2-S5iUH {
	padding-top: 12px !important;
}

.SMTPManagement-paddingTop3-vltV3 {
	padding-top: 18px !important;
}

.SMTPManagement-paddingTop4-duku5 {
	padding-top: 24px !important;
}

.SMTPManagement-paddingTop5-OEINT {
	padding-top: 30px !important;
}

.SMTPManagement-paddingTop6-fX03I {
	padding-top: 36px !important;
}

.SMTPManagement-paddingTop7-viLkd {
	padding-top: 42px !important;
}

.SMTPManagement-noPadding-cuMHz {
	padding: 0px !important;
}

.SMTPManagement-textBold-fwdcC {
	font-weight: 500 !important;
}

.SMTPManagement-textBolder-FZZKG {
	font-weight: 700 !important;
}

.SMTPManagement-textNormal-gUYgR {
	font-weight: normal !important;
}

.SMTPManagement-spaceBottom20-Hk1Nj {
	margin-bottom: 20px;
}

.SMTPManagement-spaceBottom10-LoHjO {
	margin-bottom: 10px;
}

.SMTPManagement-marginNone-eDKaO {
	margin: 0;
}

.SMTPManagement-spaceBottom15-NCW3o {
	margin-bottom: 15px;
}

.SMTPManagement-marginTopNone-jMNRb {
	margin-top: 0;
}

.SMTPManagement-spaceTop11-c3QTt {
	margin-top: 11px;
}

.SMTPManagement-spaceTop21-PL8qG {
	margin-top: 21px;
}

.SMTPManagement-spaceTop20-UhqYo {
	margin-top: 20px;
}

.SMTPManagement-spaceTop10-NaE_q {
	margin-top: 10px;
}

/*New Design Text Colors */

.SMTPManagement-textDarkBlue-F1HMf {
	color: rgb(20, 39, 94) !important;
}

.SMTPManagement-textLightBlue-AzMpc {
	color: rgb(57, 87, 106) !important;
}

.SMTPManagement-textLightSandleGreen-baorI {
	color: rgb(76, 86, 41) !important;
}

.SMTPManagement-textLightBrown-ACDkg {
	color: rgb(115, 79, 33) !important;
}

.SMTPManagement-textMediumMaroon-JO66G {
	color: rgb(87, 37, 51) !important;
}

.SMTPManagement-textBrown-TRfZr {
	color: rgb(160, 47, 24) !important;
}

.SMTPManagement-textMaroon-vJV6F {
	color: rgb(155, 49, 67) !important;
}

.SMTPManagement-textDarkBrown-Y4MFZ {
	color: rgb(83, 18, 16) !important;
}

.SMTPManagement-textMediumBrown-L2Obw {
	color: rgb(142, 28, 10) !important;
}

.SMTPManagement-textSkyBlue-drrmW {
	color: rgb(37, 117, 141) !important;
}

.SMTPManagement-textGray-yFJgp {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `SMTPManagement-commonHeaderAdmin-vFB8a`,
	"adminLayout": `SMTPManagement-adminLayout-q4BFn`,
	"box": `SMTPManagement-box-kqkZw`,
	"exportLink": `SMTPManagement-exportLink-yMKsR`,
	"blockCenter": `SMTPManagement-blockCenter-klG4r`,
	"panelHeader": `SMTPManagement-panelHeader-xaMfW`,
	"currencyselect": `SMTPManagement-currencyselect-RPiRg`,
	"mar0": `SMTPManagement-mar0-ROK5F`,
	"sideAdminPageWrapper": `SMTPManagement-sideAdminPageWrapper-KauEn`,
	"table": `SMTPManagement-table-ObOxD`,
	"tableRow": `SMTPManagement-tableRow-H2pnM`,
	"tableCell": `SMTPManagement-tableCell-LVBGo`,
	"formGroup": `SMTPManagement-formGroup-Svxsv`,
	"select": `SMTPManagement-select-kfBXd`,
	"noMargin": `SMTPManagement-noMargin-OeHJM`,
	"labelTextNew": `SMTPManagement-labelTextNew-Z3pxu`,
	"displayInline": `SMTPManagement-displayInline-vgPkj`,
	"btnUPdate": `SMTPManagement-btnUPdate-HQ8sU`,
	"btnModalDelete": `SMTPManagement-btnModalDelete-oeIW7`,
	"radioBtn": `SMTPManagement-radioBtn-DWC7f`,
	"backgroundImg": `SMTPManagement-backgroundImg-c4gkT`,
	"btnWidth": `SMTPManagement-btnWidth-aLce7`,
	"bannerImageBg": `SMTPManagement-bannerImageBg-EhXRf`,
	"bannerDelete": `SMTPManagement-bannerDelete-DFnbz`,
	"modalRoot": `SMTPManagement-modalRoot-L8MJ5`,
	"modalBorderBottom": `SMTPManagement-modalBorderBottom-lBDQY`,
	"logInModalBody": `SMTPManagement-logInModalBody-Y54zN`,
	"exportSection": `SMTPManagement-exportSection-V71Ez`,
	"exportSectionGridSub": `SMTPManagement-exportSectionGridSub-NJS2b`,
	"exportText": `SMTPManagement-exportText-t_m0C`,
	"exportLinkImg": `SMTPManagement-exportLinkImg-wb67d`,
	"vtrMiddle": `SMTPManagement-vtrMiddle-SJx_a`,
	"exportImg": `SMTPManagement-exportImg-H8HKu`,
	"profileViewlabel": `SMTPManagement-profileViewlabel-e8hUO`,
	"profileViewMainContent": `SMTPManagement-profileViewMainContent-qvYBM`,
	"profileViewMain": `SMTPManagement-profileViewMain-oB747`,
	"profileViewInner": `SMTPManagement-profileViewInner-iAK5J`,
	"profileImageSection": `SMTPManagement-profileImageSection-ieb0z`,
	"lastviewInner": `SMTPManagement-lastviewInner-EHnhV`,
	"whyHostHoriLine": `SMTPManagement-whyHostHoriLine-nRDCt`,
	"tableGrid": `SMTPManagement-tableGrid-GbUDH`,
	"headingContent": `SMTPManagement-headingContent-RAjLj`,
	"refundTextColor": `SMTPManagement-refundTextColor-sBxSw`,
	"dividerLine": `SMTPManagement-dividerLine-p82Ms`,
	"smallContent": `SMTPManagement-smallContent-G4uTZ`,
	"ChangeToUpperCase": `SMTPManagement-ChangeToUpperCase-gokHN`,
	"noBorder": `SMTPManagement-noBorder-liwoU`,
	"siteAdminHeading": `SMTPManagement-siteAdminHeading-lCRt0`,
	"siteAdminSubHeading": `SMTPManagement-siteAdminSubHeading-CJAma`,
	"adminFormDivider": `SMTPManagement-adminFormDivider-DGo7p`,
	"space1": `SMTPManagement-space1-ZQD2i`,
	"space2": `SMTPManagement-space2-z90In`,
	"space3": `SMTPManagement-space3-KB1OW`,
	"space4": `SMTPManagement-space4-PjH84`,
	"space5": `SMTPManagement-space5-AZCQb`,
	"space6": `SMTPManagement-space6-JO7T0`,
	"space7": `SMTPManagement-space7-uCjih`,
	"spaceTop8": `SMTPManagement-spaceTop8-K2dWL`,
	"spaceTop1": `SMTPManagement-spaceTop1-BSjcy`,
	"spaceTop2": `SMTPManagement-spaceTop2-oAW5i`,
	"spaceTop3": `SMTPManagement-spaceTop3-h78M2`,
	"spaceTop4": `SMTPManagement-spaceTop4-BpiOO`,
	"spaceTop5": `SMTPManagement-spaceTop5-g5MOo`,
	"spaceTop6": `SMTPManagement-spaceTop6-WHmIN`,
	"spaceTop7": `SMTPManagement-spaceTop7-cfKGM`,
	"padding1": `SMTPManagement-padding1-s2CpO`,
	"padding2": `SMTPManagement-padding2-qW52F`,
	"padding3": `SMTPManagement-padding3-0n8OX`,
	"padding4": `SMTPManagement-padding4-E1e1J`,
	"padding5": `SMTPManagement-padding5-P5mUh`,
	"padding6": `SMTPManagement-padding6-qxK_x`,
	"padding7": `SMTPManagement-padding7-Xq4u0`,
	"paddingTop1": `SMTPManagement-paddingTop1-pSQGL`,
	"paddingTop2": `SMTPManagement-paddingTop2-S5iUH`,
	"paddingTop3": `SMTPManagement-paddingTop3-vltV3`,
	"paddingTop4": `SMTPManagement-paddingTop4-duku5`,
	"paddingTop5": `SMTPManagement-paddingTop5-OEINT`,
	"paddingTop6": `SMTPManagement-paddingTop6-fX03I`,
	"paddingTop7": `SMTPManagement-paddingTop7-viLkd`,
	"noPadding": `SMTPManagement-noPadding-cuMHz`,
	"textBold": `SMTPManagement-textBold-fwdcC`,
	"textBolder": `SMTPManagement-textBolder-FZZKG`,
	"textNormal": `SMTPManagement-textNormal-gUYgR`,
	"spaceBottom20": `SMTPManagement-spaceBottom20-Hk1Nj`,
	"spaceBottom10": `SMTPManagement-spaceBottom10-LoHjO`,
	"marginNone": `SMTPManagement-marginNone-eDKaO`,
	"spaceBottom15": `SMTPManagement-spaceBottom15-NCW3o`,
	"marginTopNone": `SMTPManagement-marginTopNone-jMNRb`,
	"spaceTop11": `SMTPManagement-spaceTop11-c3QTt`,
	"spaceTop21": `SMTPManagement-spaceTop21-PL8qG`,
	"spaceTop20": `SMTPManagement-spaceTop20-UhqYo`,
	"spaceTop10": `SMTPManagement-spaceTop10-NaE_q`,
	"textDarkBlue": `SMTPManagement-textDarkBlue-F1HMf`,
	"textLightBlue": `SMTPManagement-textLightBlue-AzMpc`,
	"textLightSandleGreen": `SMTPManagement-textLightSandleGreen-baorI`,
	"textLightBrown": `SMTPManagement-textLightBrown-ACDkg`,
	"textMediumMaroon": `SMTPManagement-textMediumMaroon-JO66G`,
	"textBrown": `SMTPManagement-textBrown-TRfZr`,
	"textMaroon": `SMTPManagement-textMaroon-vJV6F`,
	"textDarkBrown": `SMTPManagement-textDarkBrown-Y4MFZ`,
	"textMediumBrown": `SMTPManagement-textMediumBrown-L2Obw`,
	"textSkyBlue": `SMTPManagement-textSkyBlue-drrmW`,
	"textGray": `SMTPManagement-textGray-yFJgp`
};
module.exports = ___CSS_LOADER_EXPORT___;
